(function () {
  // Aparición suave al hacer scroll
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: .12 }) : null;
  // las tarjetas de una misma fila entran una detrás de otra; después se quita el retraso para que el hover responda rápido
  document.querySelectorAll('.feats,.uses,.colors,.safe').forEach(function (g) {
    [].forEach.call(g.children, function (c, i) {
      c.style.transitionDelay = (i * 0.09) + 's';
      c.addEventListener('transitionend', function () { c.style.transitionDelay = ''; }, { once: true });
    });
  });
  document.querySelectorAll('.rv').forEach(function (el) { io ? io.observe(el) : el.classList.add('in'); });

  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fino = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // barra de progreso y cabecera compacta al bajar
  var barra = document.createElement('div');
  barra.className = 'progreso';
  document.body.appendChild(barra);
  var hdr = document.querySelector('.hdr');
  var pendiente = false;
  function alBajar() {
    pendiente = false;
    var alto = document.documentElement.scrollHeight - innerHeight;
    barra.style.transform = 'scaleX(' + (alto > 0 ? scrollY / alto : 0) + ')';
    if (hdr) hdr.classList.toggle('bajo', scrollY > 40);
  }
  addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(alBajar); } }, { passive: true });
  alBajar();

  // el enlace del menú se marca según la sección que se está viendo
  var enlaces = [].slice.call(document.querySelectorAll('.nav a[href*="#"]'));
  if (enlaces.length && 'IntersectionObserver' in window) {
    var ioNav = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        enlaces.forEach(function (a) { a.classList.toggle('activo', a.hash === '#' + e.target.id); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    enlaces.forEach(function (a) { var s = a.hash && document.getElementById(a.hash.slice(1)); if (s) ioNav.observe(s); });
  }

  // luz que sigue al mouse en las tarjetas
  if (fino) document.querySelectorAll('.feat,.use,.safe div').forEach(function (t) {
    t.addEventListener('pointermove', function (e) {
      var r = t.getBoundingClientRect();
      t.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      t.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });

  // el producto de la portada se inclina siguiendo el mouse
  var tilt = document.querySelector('[data-tilt]');
  if (tilt && fino && !quieto) {
    var foto = tilt.querySelector('img');
    tilt.addEventListener('pointermove', function (e) {
      var r = tilt.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      tilt.classList.add('tilt');
      foto.style.transform = 'rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg) scale(1.02)';
    });
    tilt.addEventListener('pointerleave', function () { foto.style.transform = ''; tilt.classList.remove('tilt'); });
  }

  var form = document.querySelector('[data-order]');
  if (!form) return;
  var unit = parseInt(form.dataset.unit, 10);
  var pair = parseInt(form.dataset.pair, 10);
  var qty = form.querySelector('[name="quantity"]');
  var totalEl = form.querySelector('[data-total]');
  var oldEl = form.querySelector('[data-old]');
  var mainImg = document.querySelector('[data-main-img]');
  var bundle = form.querySelector('[data-bundle]');
  var fmt = function (c) { return 'RD$' + Math.round(c / 100).toLocaleString('en-US'); };

  // Desde 2 unidades aplica el descuento de la oferta (cada unidad sale a la mitad de "pair")
  function total(q) { return q >= 2 ? Math.round(q * unit * pair / (2 * unit)) : unit; }
  function cantidad() { return Math.min(10, Math.max(1, parseInt(qty.value, 10) || 1)); }
  var antes = '';
  function render() {
    var q = cantidad();
    qty.value = q;
    var t = total(q), full = q * unit;
    totalEl.textContent = fmt(t);
    oldEl.textContent = t < full ? fmt(full) : '';
    // el total salta cuando cambia, y con la oferta se muestra cuánto se ahorra
    var tag = form.querySelector('.ahorro-tag');
    if (t < full) {
      if (!tag) { tag = document.createElement('span'); tag.className = 'ahorro-tag'; totalEl.parentNode.appendChild(tag); }
      tag.textContent = 'Ahorras ' + fmt(full - t);
    } else if (tag) tag.remove();
    if (bundle) bundle.classList.toggle('hecho', q >= 2);
    if (antes && antes !== totalEl.textContent) {
      totalEl.classList.remove('salta'); void totalEl.offsetWidth; totalEl.classList.add('salta');
    }
    antes = totalEl.textContent;
  }
  function cambiarFoto(src) {
    if (!mainImg || !src || mainImg.src === src) return;
    mainImg.classList.add('cambia');
    setTimeout(function () { mainImg.src = src; mainImg.onload = function () { mainImg.classList.remove('cambia'); }; }, 180);
    setTimeout(function () { mainImg.classList.remove('cambia'); }, 900);
  }
  form.querySelectorAll('[data-step]').forEach(function (b) {
    b.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.step, 10); render(); });
  });
  qty.addEventListener('input', render);
  if (bundle) bundle.addEventListener('click', function () { qty.value = 2; render(); });

  // Color: cambia la foto grande
  form.querySelectorAll('[name="id"]').forEach(function (r) {
    r.addEventListener('change', function () { cambiarFoto(r.dataset.img); });
  });
  document.querySelectorAll('[data-pick]').forEach(function (c) {
    c.addEventListener('click', function () {
      var r = form.querySelector('[name="id"][data-color="' + c.dataset.pick + '"]');
      if (r) { r.checked = true; r.dispatchEvent(new Event('change')); }
      document.getElementById('comprar').scrollIntoView();
    });
  });
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      cambiarFoto(t.dataset.thumb);
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  // Confirmar: se revisan los datos, se manda una copia al correo de la tienda y se abre WhatsApp con el pedido escrito
  var pf = form.querySelector('[data-pedido]');
  if (!pf) return;
  var boton = pf.querySelector('[type="submit"]');
  var abrir = pf.querySelector('[data-abrir]');
  var datos = pf.querySelector('[data-datos]');
  // «Comprar ahora» despliega los datos de entrega; recién ahí aparece el botón de WhatsApp
  function abrirPedido(enfocar) {
    if (abrir.disabled) return;
    if (!datos.hidden) { (enfocar ? datos : form).scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    datos.hidden = false;
    abrir.hidden = true;
    boton.hidden = false;
    pf.querySelector('[data-aviso]').hidden = false;
    // desde el botón se va a los datos; desde «Pedir ahora» se va arriba, para que elija color y cantidad
    (enfocar ? datos : form).scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (enfocar) setTimeout(function () { pf.querySelector('[name="nombre"]').focus({ preventScroll: true }); }, 350);
  }
  abrir.addEventListener('click', function () { abrirPedido(true); });
  document.querySelectorAll('a[href="#comprar"]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (abrir.disabled) return; e.preventDefault(); abrirPedido(false); });
  });
  var error = pf.querySelector('[data-error]');
  var listo = pf.querySelector('[data-listo]');
  function campo(n) { return (pf.querySelector('[name="' + n + '"]').value || '').trim(); }
  function marcar(n, mal) { pf.querySelector('[name="' + n + '"]').closest('.campo').classList.toggle('mal', mal); }

  pf.addEventListener('submit', function (e) {
    e.preventDefault();
    var d = { nombre: campo('nombre'), telefono: campo('telefono'), provincia: campo('provincia'), direccion: campo('direccion'), nota: campo('nota') };
    var digitos = d.telefono.replace(/\D/g, '');
    var faltan = [];
    marcar('nombre', d.nombre.length < 3); if (d.nombre.length < 3) faltan.push('tu nombre');
    marcar('telefono', digitos.length < 10); if (digitos.length < 10) faltan.push('un teléfono de 10 dígitos');
    marcar('provincia', !d.provincia); if (!d.provincia) faltan.push('tu provincia');
    marcar('direccion', d.direccion.length < 8); if (d.direccion.length < 8) faltan.push('la dirección completa');
    if (faltan.length) {
      error.textContent = 'Falta ' + faltan.join(', ').replace(/, ([^,]*)$/, ' y $1') + '.';
      error.hidden = false;
      pf.querySelector('.campo.mal input, .campo.mal select').focus();
      return;
    }
    error.hidden = true;
    var q = cantidad(), color = (pf.querySelector('[name="id"]:checked') || {}).dataset;
    var msg = [
      'Hola OZAMA, quiero hacer este pedido:',
      '',
      '• ' + q + ' × ' + pf.dataset.producto + ' — color ' + (color ? color.color : ''),
      '• Total a pagar al recibir: ' + fmt(total(q)) + ' (envío gratis)',
      '',
      'Nombre: ' + d.nombre,
      'Teléfono: ' + d.telefono,
      'Provincia: ' + d.provincia,
      'Dirección: ' + d.direccion
    ];
    if (d.nota) msg.push('Comentario: ' + d.nota);
    msg.push('', '¿Me confirman para cuándo llega?');
    var texto = msg.join('\n');
    var url = 'https://wa.me/' + boton.dataset.num + '?text=' + encodeURIComponent(texto);

    // copia por correo (si falla, el pedido igual va por WhatsApp)
    var copia = document.getElementById('pedido-copia');
    if (copia && window.fetch) {
      copia.querySelector('[name="contact[name]"]').value = d.nombre;
      copia.querySelector('[name="contact[phone]"]').value = d.telefono;
      copia.querySelector('[name="contact[body]"]').value = 'PEDIDO WEB\n\n' + texto;
      try { fetch(copia.action, { method: 'POST', body: new FormData(copia), keepalive: true }).catch(function () {}); } catch (x) {}
    }
    boton.disabled = true;
    listo.querySelector('[data-wa-otra]').href = url;
    listo.hidden = false;
    setTimeout(function () { boton.disabled = false; }, 4000);
    window.location.href = url;
  });
  pf.querySelectorAll('.campo input, .campo select').forEach(function (el) {
    el.addEventListener('input', function () { el.closest('.campo').classList.remove('mal'); });
  });
  render();
})();
